import { UseFormReturn } from 'react-hook-form'
import { Icon20 } from 'cio-design-library/icons'
import { TextField } from 'builder/components/TextField'

import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import * as Styles from './styles'
import { FullNameFormData } from './types'

const TRANSLATION = 'builder.dashboard.learning_hub.full_name_modal'

type Props = {
  form: UseFormReturn<FullNameFormData>
  isUserUpdating: boolean
  onClose: () => void
  onSubmit: (data: FullNameFormData) => void
}

export const FullNameForm = ({ form, isUserUpdating, onClose, onSubmit }: Props) => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const { errors } = form.formState
  const required = i18n.t(`${TRANSLATION}.required_field`)

  return (
    <Styles.Container>
      <Styles.HeaderContainer>
        <Styles.InfoContainer>
          <Styles.InfoHeader>{i18n.t(`${TRANSLATION}.title`)}</Styles.InfoHeader>
          <Styles.InfoDescription>{i18n.t(`${TRANSLATION}.description`)}</Styles.InfoDescription>
        </Styles.InfoContainer>
        {!isPhone && (
          <Styles.CloseButton onClick={onClose}>
            <Styles.IconContainer>
              <Icon20.Close />
            </Styles.IconContainer>
          </Styles.CloseButton>
        )}
      </Styles.HeaderContainer>

      <Styles.Form onSubmit={form.handleSubmit(onSubmit)}>
        <Styles.InputRow>
          <TextField
            {...form.register('firstName', { required })}
            label={i18n.t(`${TRANSLATION}.first_name`)}
            placeholder="John"
            error={errors.firstName?.message}
            autoFocus
          />
        </Styles.InputRow>

        <Styles.InputRow>
          <TextField
            {...form.register('lastName', { required })}
            label={i18n.t(`${TRANSLATION}.last_name`)}
            placeholder="Appleseed"
            error={errors.lastName?.message}
          />
        </Styles.InputRow>

        <Styles.ActionsContainer>
          <Styles.CancelButton type="button" onClick={onClose}>
            {i18n.t(`${TRANSLATION}.cancel`)}
          </Styles.CancelButton>
          <Styles.ConfirmButton isLoading={isUserUpdating} type="submit">
            {i18n.t(`${TRANSLATION}.continue`)}
          </Styles.ConfirmButton>
        </Styles.ActionsContainer>
      </Styles.Form>
    </Styles.Container>
  )
}
